var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.002,
    height: 18.008,
    viewBox: "0 0 24.002 18.008",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "code",
    d: "M7.754,15.1l-.656.656a.412.412,0,0,1-.6,0L.383,9.645a.412.412,0,0,1,0-.6L6.5,2.93a.412.412,0,0,1,.6,0l.656.656a.412.412,0,0,1,0,.6L2.6,9.343,7.754,14.5a.412.412,0,0,1,0,.6ZM15.506,1.107,10.613,18.039a.428.428,0,0,1-.2.256.366.366,0,0,1-.308.033L9.289,18.1a.428.428,0,0,1-.256-.2A.392.392,0,0,1,9,17.58L13.893.647a.428.428,0,0,1,.2-.256A.364.364,0,0,1,14.4.359l.813.223a.428.428,0,0,1,.256.2A.39.39,0,0,1,15.506,1.107Zm8.617,8.538-6.112,6.112a.412.412,0,0,1-.6,0l-.656-.656a.412.412,0,0,1,0-.6l5.155-5.155L16.752,4.189a.412.412,0,0,1,0-.6l.656-.656a.412.412,0,0,1,.6,0l6.112,6.112a.412.412,0,0,1,0,.6Z",
    transform: "translate(-0.252 -0.339)",
    fill: "#a2a1a1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.2f0aec42.svg";
export { ForwardRef as ReactComponent };